import styled from "styled-components";

export const StyledToggleCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
`;
